import { render, staticRenderFns } from "./m-empty.vue?vue&type=template&id=77621536&scoped=true&"
import script from "./m-empty.vue?vue&type=script&lang=ts&setup=true&"
export * from "./m-empty.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77621536",
  null
  
)

export default component.exports